import { Theme } from '@mui/material'

import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  headingContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  contractDurationHeading: {
    color: theme.palette.text.secondary,
    fontSize: '18px',
    textAlign: 'left',
    fontWeight: 600,
    margin: theme.spacing(1.75, 0, 2, 0),
  },
}))
